module.exports = __webpack_public_path__ + "img/k_qianbao.4096afc2.png";